export const STEPS = Object.freeze({
  MAIN: 'main',
  WORKSPACE: 'workspace',
  PROJECT: 'project',
  COURSEWARE: 'courseware',
  UNIT: 'unit',
});

export const publishFormat = Object.freeze({
  EPUB: 'EPUB_ETEXT',
  CHANNEL_PARTNER: 'EPUB_CHANNEL_PARTNER',
  CLASS_ON_DEMAND: 'BRONTE_CLASSES_ON_DEMAND',
  PEARSON_PLUS: 'BRONTE_PEARSON_PLUS',
  PEARSON_PLUS_TEST: 'BRONTE_PEARSON_PLUS_TEST_ONLY',
  IN_DESIGN: 'IN_DESIGN',
});

export const permissionTypes = Object.freeze({
  OWNER: 'OWNER',
  CONTRIBUTOR: 'CONTRIBUTOR',
  REVIEWER: 'REVIEWER',
});

export const publishType = Object.freeze({
  RELEASE_FOR_LIVE: 'releaseForLive',
  RELEASE_FOR_REVIEW: 'releaseForReview',
  MINOR_CONTENT_UPDATE: 'minorContentUpdate',
  MAJOR_CONTENT_UPDATE: 'majorContentUpdate',
});

export const disciplines = Object.freeze({
  A_AND_P: 'aAndB',
  ASTRONOMY: 'astronomy',
  BIOLOGY: 'biology',
  CHEMISTRY: 'chemistry',
  ENGINEERING: 'engineering',
  ENVIRONMENTAL_SCIENCE: 'environmentalScience',
  MICROBIOLOGY: 'microbiology',
  PHYSICS: 'physics',
});

export const sortType = Object.freeze({
  ASC: 'asc',
  DESC: 'desc',
});

export const publicationsModel = {
  title: '',
  author: '',
  activityId: '',
  updatedAt: '',
  publishedBy: '',
  publisherGivenName: '',
  publisherFamilyName: '',
  history: [],
};

export const status = Object.freeze({
  // publish status
  PUBLISH_STARTED: 'STARTED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PEARSONPLUS_TITLE_INGEST_COMPLETE: 'PEARSONPLUS_TITLE_INGEST_COMPLETE',
  INDEX_IN_PROGRESS: 'INDEX_IN_PROGRESS',
  // export status
  SNIPPET_COMPLETE: 'INPROGRESS',
  INPROGRESS: 'INPROGRESS',
  COMPLETE: 'COMPLETED',
  ERROR: 'FAILED',
});

export const svgIconType = Object.freeze({
  CONTENT_COPY: 'contentCopy',
  INFO_ICON: 'infoIcon',
  FILE_CHECK: 'fileCheck',
});

export const actionType = Object.freeze({
  CHECK_REPORT: 'CHECK_REPORT',
  OUTPUT_INFO: 'OUTPUT_INFO',
  PUBLISH: 'PUBLISH',
  DELETE: 'DELETE',
  PRE_SIGNED_URL: 'PRE_SIGNED_URL',
  GENERATE_URNS: 'GENERATE_URNS',
  VERSION_CHANGES: 'VERSION_CHANGES',
  DOWNLOAD_SB_MEDIA_GRID : 'DOWNLOAD_SB_MEDIA_GRID',
});

export const timeFormats = Object.freeze({
  DATE_MONTH: "DD MMM YYYY hh:mm A",
  MONTH_DATE: "MMMM DD, YYYY, hh:mm A",
});

export const headerKey = {
  NAME: 'title',
  AUTHOR: 'author',
  PUBLISHED_BY: 'publisherGivenName',
  LAST_MODIFIED: 'updatedAt',
};

export const invalidAuthorNames = ['', 'author name'];

export const tableOfContents = Object.freeze({
  TWO_LEVELS: 'Two Levels',
  THREE_LEVELS: 'Three Levels',
});

export const OCULUS_PUBLISHED_LIVE = 'PUBLISHED LIVE';

export const SB_MEDIA_GRID_FILE_SUFFIX= 'SB-Media-Grid.csv'; 